import React from 'react';
import styled from 'styled-components';
import { Picture } from '../../components';
export default function UiImageList({ model: { content: { images } } }) {
    return (React.createElement(List, null, images.map(({ title, width, height, url }) => (React.createElement("li", { key: url },
        React.createElement(Picture, { image: { url, title, width, height } }))))));
}
const List = styled.ul `
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 1rem;
  li {
    display: flex;
    padding: 0 1rem 1rem;
    img {
      display: block;
      margin: auto;
    }
  }
`;
//# sourceMappingURL=UiImageList.js.map